// extracted by mini-css-extract-plugin
export var container = "_a1-1";
export var cornerButtonContainer = "_a1-5";
export var disabled = "_a1-2";
export var fileContainer = "_a1-4";
export var hiddenInput = "_a1-3";
export var widthContainer = "_a1-0";